<template>
  <div class="common-problem">
    <van-tabs v-model="active" scrollspy sticky>
      <van-tab v-for="(item,index) in list" :title="item.title" :key="index">
        <div class="content-box" v-for="(child ,i) in item.content" :key="index + '-' + i">
          <h3 class="content-title" >{{child.title}}</h3>
          <p v-for="(child ,k) in child.contentList" :key="index + '-' + i + '-'+k">{{child}}</p>
        </div>
        
      </van-tab>
    </van-tabs>
    <div style="height:500px"></div>
  </div>
</template>
<script>
import { Tab, Tabs } from "vant";
export default {
  name: 'common-problem',
  data(){
    return{
      active: 0,
      list: [
        { 
          title: '充电异常',
          content: [
            {
              title: '不显示"已插枪"',
              contentList: [
                '1.请确认车辆熄火，并且充电枪连接到位；',
                '2.请检查设备急停按钮是否被按下，如果被按下，请按照急停按钮的指示方向旋转一下，急停按钮弹出后即表示设备已恢复正常，请尝试重新插枪再启动充电.如还不能启动充电，可能是设备故障，建设您更换其它设备充电，或者联系客服。',
              ]
            },
            {
              title: '启动充电失败',
              contentList: [
                '1.请确认车辆熄火，并且充电枪连接到位；',
                '2.启动失败后，App会提示失败原因以及建议的解决方案，请尝试按照解决方案进行操作：',
                '3.跳枪后App订单会显示充电终止原因',
                '4.如仍然启动失败，或多次跳枪，建议您更换其他设备充电，或咨询客服'
              ]
            },
            {
              title: '跳枪',
              contentList: [
                '1.确保充电过程中保持车辆熄火，并且充电枪连接到位，若车辆未熄火请熄火后重新启动充电',
                '2.跳枪后公众号订单上会显示充电终止原因，如有疑问请咨询客服，'
              ]
            },
            {
              title: '带电拔枪',
              contentList: [
                '充电过程中请勿通过拔枪或按下急停按钮的方式停止充电，否则会影响电池寿命并对车辆充电接口造成损伤,请务必通过点击公众号上的停止按钮结束充电或车辆充满自动停止后,再拨枪驶离。'
              ]
            },
            {
              title: '二维码破损',
              contentList: [
                '因设备二维码破损导致无法扫码，您可以先摘枪，进入 App扫码页面，通过点击扫码页面的”当前电站”进入已插枪终端列表，选择相应的已插枪终端启动充电即可。（已插枪终端列表优先显示最新插枪的终端，开启充电后请确认您的爱车仪表盘显示充电中再离开，以免充错车辆）'
              ]
            },
            {
              title: '手机网络信号差',
              contentList: [
                '因手机网络信号差导致无法扫码充电，您可以先插枪，将终端上的二维码拍照，到网络畅通的地方，通过扫码页面的识别二维码图片功能启动充电即可'
              ]
            },
            {
              title: '无法停止充电',
              contentList: [
                '设备由于断电或 信号不好等情况离网后，充电中的订单将被挂起，挂起期间无法结束充电，您可以直接拔枪驶离．设备恢复正常后，订单将自动结束，订单费用将按照您实际的充电电量计费。'
              ]
            },
            {
              title: '安全防护终止',
              contentList: [
                '系统研发并建立了两层安全防护体系：CMS（智能充电管理系统）主动防护和在数据安全防护。',
                '在 BMS （电池管理系统 〕 控制整车充电行为的同时， CMS 会进行二次检测，发现异常时，会触发主动防护及时终止充电订单，保护充电安全。系统 CMS 主动防护技术体系具体包含了充电电压不匹配、控制器通信故障、电池过温、电池低温、电池温度异常、电池过冲等 11 种防护模型。',
                '在 CMS 基础之上，系统建立了基于大数据的第二层安全防护体系，涵盖了 8 种防护模型。',
                '如栗触发了主动防护的11种指标之一或者大数据的8种指标之一,则会被停止充电'
              ]
            }
          ]
        },
        { 
          title: '充电贴士',
          content: [
            {
              title: '电量不准',
              contentList: [
                '电动汽车的充电，与充电机、电池，以及电池的加热散热系统有关。',
                '电动汽车在交流充电时，使用的车载充电机，所以会在充电过程中产生车载充电机的整流损耗.电车充电损耗以及电车的散热和加热系统的损耗.这三部分的影响，导致公众号中显示的充电量要大于电池充电量。',
                '电动汽车在直流充电时，充电机位于充电桩内，所以系统会承担整个充电流程的电损.但不排除使用其他品牌充电桩时，充电桩不承担电损，直流充电的电量和电池电量会有差距'
              ]
            },
            {
              title: '电流不一致',
              contentList: [
                '电动汽车在交流充电过程中，公众号显示的是交流电输入电流，为220V，30A(15A)左右电流，而车内显示的是20A(10A)的电流出现显示不一致的原因是车内显示的直流电是电压升压到300V左右的结果，电流会变小.但因为功率是不变的，所以大家只要注意车内和公众号中显示的功率是否一致即可',
              ]
            },
            {
              title: '快充？慢充？',
              contentList: [
                '电池是我们电动汽车的核心，如何有效减少车辆电池的衰减，是延长电动汽车使用寿命的关键，系统运维专家建议，大家可以根据自己的出行特点，快充和慢充结合使用，不必要刻意追求用一种充电方式',
                '在快充使用过程中，每月尽量使用2-3次交流慢充，这样可以对电池的一致性进行调整，并且有利于延长电池使用寿命。同时，建议大家养成"浅充浅放"的充电习惯，尽量不要把电池用干净再充，也不要长时间不使用车辆。'
              ]
            },
            {
              title: '冬季充电',
              contentList: [
                '1.冬季温度较低的情况下，每次驾驶电动汽车时先低速慢行一段时间，让电池逐步升温，驾驶时尽量避免急加速',
                '2.爰车行驶完后，尽量在热车状态下充电，这样能更好的延迟电池的使用寿命。'
              ]
            },
            {
              title: '雨雪天充电',
              contentList: [
                '冬季易有雨雪天气，这时空气会变得潮湿.很多小伙伴担心空气的湿度会影响绝缘，谞大家放心，系统的充电插头是无电插头，在充电粧与车发生连接并启动充电之前，桩本身也是不带电的。因此，秋冬的雨雪天气，大家在充电时，只要车辆接口不处于雨中、枪头是干燥的，就可以正常启动充电。'
              ]
            },
            {
              title: '如何设置SOC达到目标值终止',
              contentList: [
                '通过公众号在启动页面，使用直流快充充电时，设置SOC目标值后，当SOC达到相应的目标值后将自动停止充电'
              ]
            },
            {
              title: '如何开启启动提醒',
              contentList: [
                '关注公众号后，启动充电、结束充电、超时占用等都会收到微信提醒。'
              ]
            },
            
          ],
        },
        { 
          title: '特享服务',
          content: [
            {
              title: '道闸识别',
              contentList: [
                '部分电站设有道闸识別系统，爰车认证后方可被道闸识別进出，驶入场站前请劳必通过公众号认证爰车，如栗爰车认证失败或临牌车辆，请联系客服开闸。'
              ]
            },
            {
              title: '超时占用费',
              contentList: [
                '为了让更多的电动汽车用户享受到充电服务，对于充满电后长时间不挪车的车主，我们将收取一定的超时占用费，请留意电站和终端详情内的相关收费信息。关注公众号 ,可接收超时占用提醒'
              ]
            },
            {
              title: '地锁使用',
              contentList: [
                '为有效杜绝油车占位问题，部分电站已加装地锁。对于安装摄像头的车位，爱车认证后驶入车位时将目动为您解锁，未安装摄像头的车位，需要您手动扫码解锁。'
              ]
            },
            // {
            //   title: '网约车认证',
            //   contentList: [
            //     '如果您是网约车司机，通过公众号认证网约车后，在公众号充电可这享受专享优惠.可通过公众号进行认证。'
            //   ]
            // }
          ],
        },
        { 
          title: '充值退款',
          content: [
            {
              title: '如何充值',
              contentList: [
                '登录公众号，进入“我的—充值”页面，选择或输入充值金额进行充值。'
              ]
            },
            {
              title: '如何退款',
              contentList: [
                '登录公众号，进入“我的—充值”页面最底部点击申请退款，输入退款金额，申请通过后即可原路返回，如有疑问，可联系客服。'
              ]
            },
            
          ],
        },
        { 
          title: '账号安全',
          content: [
            {
              title: '收不到短信验证码',
              contentList: [
                '网络通讯出现异常的情况下可能会造成短信丟失或延时收到，需要您耐心等待一下。同时建议您确认手机是否有拦截短信等设置，是否跟运营商反馈过垃圾短信等，如果您始终未收到，请联系客服咨询解决。'
              ]
            },
            {
              title: '更换手机号',
              contentList: [
                '登录公众号“我的”，点击头像进入“人个中心”即可操作更换手机号。'
              ]
            },
          ],
        },
        { 
          title: '文明充电',
          content: [
            {
              title: '文明充电',
              contentList: [
                '为了保证充电桩的稳定运行，日常使用过程中需要注意以下几点：',
                '1.充电完成后，注意将充电枪复位，不要直接丢在地上；',
                '2.充电枪从桩体拔出和复位时，注意將充电枪电线理顺，避免扭曲；',
                '3.充电时注意不要用钥匙等尖锐物品点击显示屏；',
                '4.充电枪插拔时，注意调整好角度，均匀发力，避免暴力插拔：',
                '5.非紧急状态切勿按下急停按钮；',
                '6.充电时，注意先点击屏幕或通过公众号结束充电后再拔枪。',
              ]
            },
          ],
        },
      ]
    }
  },
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  methods: {
    
  }
}
</script>
<style lang="less">
  .common-problem{
    background-color: #fff;
    .van-tabs__line{
      background-color:#14CC80;
    }
    .content-box{
      padding: 0 0.2rem;
    }
    .content-title{
      font-size: 0.38rem;
      line-height: 0.46rem;
      margin-top: 0.4rem;
      margin-bottom: 0.15rem;
      color:#000;
    }
    p{
      font-size: 0.28rem;
      line-height: 0.4rem;
      color: #666;
    }
  }
</style>